// @flow
import type { KeyboardButtonsProps } from '../index';
import React from 'react';
import Box from '../../Box';
import KbButton from '../StandardButton';
import Icon from '../../../../browser/components/Icon';
import messages from '../messages/buttons';
import { injectIntl } from 'react-intl';

class Buttons extends React.PureComponent {
  props: KeyboardButtonsProps;

  render() {
    const { onPress, disabled, intl } = this.props;

    return (
      <Box>
        <Box flexDirection="row">
          <KbButton char={7} onPress={onPress} borderRight borderTop disabled={disabled} />
          <KbButton char={8} onPress={onPress} borderRight borderTop disabled={disabled} />
          <KbButton char={9} onPress={onPress} borderTop disabled={disabled} />
        </Box>
        <Box flexDirection="row">
          <KbButton char={4} onPress={onPress} borderRight borderTop disabled={disabled} />
          <KbButton char={5} onPress={onPress} borderRight borderTop disabled={disabled} />
          <KbButton char={6} onPress={onPress} borderTop disabled={disabled} />
        </Box>
        <Box flexDirection="row">
          <KbButton char={1} onPress={onPress} borderRight borderTop disabled={disabled} />
          <KbButton char={2} onPress={onPress} borderRight borderTop disabled={disabled} />
          <KbButton char={3} onPress={onPress} borderTop disabled={disabled} />
        </Box>
        <Box flexDirection="row">
          <KbButton char={0} onPress={onPress} borderRight borderTop disabled={disabled} />
          <KbButton char={intl.formatMessage(messages.dot)} onPress={onPress} borderRight borderTop sendChar="." />
          <KbButton char="del" onPress={onPress} borderTop primary disabled={disabled}>
            <Icon name="key-delete" scale={4} color="white" justifyContent="center" />
          </KbButton>
        </Box>
      </Box>
    );
  }
}

export default injectIntl(Buttons);
